import React, { useState } from "react";
import { account_profile_status } from "../../api/fetch";

const RejectDriverModal = ({ Reject, rowData, handlerefresh }) => {
  const [rejectReasons, setRejectReasons] = useState([]);
  const [otherReason, setOtherReason] = useState("");
  const [otherCheckBox, setOtherCheckBox] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const reasonsList = [
    "Incorrect Documents",
    "Documents are not completed.",
    "Unprofessional Behavior",
  ];

  const handleCheckboxChange = (e) => {
    const reason = e.target.value;

    setRejectReasons((prev) =>
      prev.includes(reason)
        ? prev.filter((item) => item !== reason)
        : [...prev, reason]
    );
  };

  const handleOtherReasonChange = (e) => {
    const value = e.target.value;
    setOtherReason(value);

    if (otherCheckBox && value.trim()) {
      setRejectReasons((prev) => {
        // Remove the previous "Other" reason if it exists
        const filteredReasons = prev.filter((item) => item !== otherReason);
        return [...filteredReasons, value];
      });
    }
  };

  const handleReject = async () => {
    if (rejectReasons.length === 0) {
      alert("Please select at least one reason.");
      return;
    }

    setIsSubmitting(true);

    const body = {
      id: rowData?.id,
      mobile_number: rowData?.mobile_number,
      //   pstatus: Reject ? false : true,
      rejectProfile: true,
      reasons: rejectReasons,
    };

    await account_profile_status(body)
      .then(() => {
        alert(
          `${
            rowData?.driver_name
          } has been rejected for reasons: ${rejectReasons.join(", ")}`
        );
        handlerefresh();
        setIsModalVisible(false);
      })
      .catch((error) => {
        console.log("Error:", error);
        alert("Something went wrong.");
      })
      .finally(() => {
        setIsSubmitting(false);
        setIsModalVisible(false);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    alert("Your Driver Record is safe :)");
  };

  return (
    <div>
      <button
        onClick={() => {
          document.getElementById("rejectModal").classList.remove("hidden");
          setIsModalVisible(true);
        }}
        className="px-10 py-3 flex flex-row gap-3 bg-red-500 text-white text-lg font-Poppins font-medium rounded-lg shadow hover:bg-red-400 transition duration-300"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="size-6"
        >
          <path
            fillRule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </svg>
        Reject
      </button>

      <div
        id="rejectModal"
        className={`fixed inset-0 z-50 ${
          isModalVisible ? "flex" : "hidden"
        } bg-black bg-opacity-50 justify-center items-center`}
      >
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
          <h2 className="text-3xl font-bold text-center text-gray-800">
            Reject Driver
          </h2>
          <p className="mt-2 text-center text-gray-600 text-lg">
            Please select the reason(s) for rejection:
          </p>

          <div className="mt-4">
            {reasonsList?.map((reason) => (
              <label key={reason} className="block text-lg text-gray-700">
                <input
                  type="checkbox"
                  value={reason}
                  onChange={handleCheckboxChange}
                  className="mr-2 leading-tight"
                />
                {reason}
              </label>
            ))}

            <label className="block text-lg text-gray-700">
              <input
                type="checkbox"
                className="mr-2 leading-tight"
                onChange={() => {
                  setOtherCheckBox(!otherCheckBox);
                  if (!otherCheckBox) {
                    setRejectReasons((prev) => [...prev, otherReason.trim()]);
                  } else {
                    setRejectReasons((prev) =>
                      prev.filter((item) => item !== otherReason)
                    );
                    setOtherReason("");
                  }
                }}
              />
              Other
            </label>

            {otherCheckBox && (
              <input
                type="text"
                placeholder="Search..."
                className="border border-gray-300 rounded-lg px-4 py-2 my-2 pr-10 w-full focus:outline-none focus:ring focus:border-blue-300"
                value={otherReason}
                onChange={handleOtherReasonChange}
              />
            )}
          </div>

          <div className="mt-6 flex justify-end">
            <button
              onClick={handleCancel}
              className="px-4 py-2 bg-gray-300 text-gray-700 text-lg rounded-md hover:bg-gray-400 transition duration-200 mr-2"
            >
              Cancel
            </button>
            <button
              onClick={handleReject}
              className="px-4 py-2 bg-red-500 text-white text-lg rounded-md hover:bg-red-600 transition duration-300"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Rejecting..." : "Reject"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectDriverModal;
